import React, { useState, useEffect } from 'react';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const DriverLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isActive = (path) => location.pathname === path;

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-primary text-white p-4 shadow-lg sticky top-0 z-40">
        <div className="container mx-auto flex justify-between items-center">
          <Link to="/driver" className="flex items-center gap-2">
            <span className="text-2xl">🚗</span>
            <div>
              <h1 className="text-lg font-bold">Tu<span className="text-gold">pastel</span></h1>
              <p className="text-xs text-gray-300">Motorizado</p>
            </div>
          </Link>
          
          <nav className="hidden md:flex items-center gap-2">
            <Link
              to="/driver"
              className={`px-4 py-2 rounded-full text-sm font-medium transition ${
                isActive('/driver') ? 'bg-gold text-white' : 'hover:bg-white/10'
              }`}
            >
              🏠 Dashboard
            </Link>
            <Link
              to="/driver/pedidos"
              className={`px-4 py-2 rounded-full text-sm font-medium transition ${
                isActive('/driver/pedidos') ? 'bg-gold text-white' : 'hover:bg-white/10'
              }`}
            >
              📋 Mis entregas
            </Link>
            <button
              onClick={handleLogout}
              className="px-4 py-2 rounded-full text-sm font-medium text-red-300 hover:bg-red-500/10 transition"
            >
              🚪 Salir
            </button>
          </nav>

          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="md:hidden p-2 rounded-full hover:bg-white/10 transition"
            aria-label="Menú"
          >
            <div className="w-6 h-5 flex flex-col justify-between">
              <span className={`w-full h-0.5 bg-white transition-all ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
              <span className={`w-full h-0.5 bg-white transition-all ${menuOpen ? 'opacity-0' : ''}`} />
              <span className={`w-full h-0.5 bg-white transition-all ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
            </div>
          </button>
        </div>

        {menuOpen && (
          <div className="md:hidden mt-4 pt-4 border-t border-white/10 space-y-2">
            <div className="flex items-center gap-3 pb-3 mb-3 border-b border-white/10">
              <div className="w-10 h-10 rounded-full bg-gold flex items-center justify-center font-bold">
                {user?.name?.charAt(0).toUpperCase() || '?'}
              </div>
              <div>
                <p className="font-medium">{user?.name}</p>
                <p className="text-xs text-gray-400">Motorizado</p>
              </div>
            </div>
            <Link
              to="/driver"
              className={`flex items-center gap-3 px-4 py-3 rounded-xl transition ${
                isActive('/driver') ? 'bg-gold' : 'hover:bg-white/10'
              }`}
            >
              🏠 Dashboard
            </Link>
            <Link
              to="/driver/pedidos"
              className={`flex items-center gap-3 px-4 py-3 rounded-xl transition ${
                isActive('/driver/pedidos') ? 'bg-gold' : 'hover:bg-white/10'
              }`}
            >
              📋 Mis entregas
            </Link>
            <button
              onClick={handleLogout}
              className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-red-300 hover:bg-red-500/10 transition"
            >
              🚪 Cerrar sesión
            </button>
          </div>
        )}
      </header>

      <main className="container mx-auto px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
};

export default DriverLayout;
